// Per-category fallback options (used while the API call is in flight).
// The real taxonomy lives on the backend in recover/reason_categories.py
// and is hydrated into Redux on mount via getReasonCategories.
export const REASON_CATEGORY_FALLBACK = [
  { value: "fraudulent", label: "Fraudulent" },
  { value: "product_not_received", label: "Product not received" },
  { value: "product_unacceptable", label: "Product unacceptable" },
  { value: "subscription_canceled", label: "Subscription canceled" },
  { value: "credit_not_processed", label: "Credit not processed" },
  { value: "duplicate", label: "Duplicate" },
  { value: "unrecognized", label: "Unrecognized" },
  { value: "general", label: "General" }
]
